import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Merge Tailwind class strings, deduplicating conflicts (later wins).
// Lets components define a base variant in cva() and callers override
// individual utilities without specificity battles or accidentally
// stacking `px-3` and `px-5` on the same node.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
